// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ExkvC","title":"styles_title__LLecZ","description":"styles_description___n9LP"};